// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2AI0b","dense":"_type_dense__25rz2","slide-fwd-right":"_type_slide-fwd-right__RacXV"};